var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canRoute)?_c('div',{staticStyle:{"height":"100vh"},attrs:{"id":"app"}},[_c('RouterView')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }